<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="ibox login-content">
  <div class="text-center">
    <span class="auth-head-icon"><em class="la la-key"></em></span>
  </div>

  <div class="ibox-head justify-content-center">
    <div class="ibox-title text-uppercase text-center" i18n="@@changePassword">Change password</div>
  </div>

  <div class="ibox-body">
    <form [formGroup]="resetPasswordFG" #resetPasswordForm="ngForm" (ngSubmit)="resetPasswordFormSubmit()">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
        <app-input-password controlName="password" i18n-label="@@newPassword" label="New password"
                            [formGroup]="resetPasswordFG"
                            [submitted]="resetPasswordForm?.submitted"></app-input-password>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
        <app-input-password controlName="confirm" i18n-label="@@confirmPassword" label="Confirm password"
                            [formGroup]="resetPasswordFG"
                            [submitted]="resetPasswordForm?.submitted"></app-input-password>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <button class="btn btn-success btn-block btn-rounded text-uppercase" i18n="@@edit">Edit</button>
      </div>
    </form>
  </div>
</div>
